/**
 * Created by shubham on 8/5/18.
 */

import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MdDialog } from '@angular/material';
import { HttpService } from '../../shared/services/http.service';
import { SessionHandler } from '../../shared/services/session-handler.service';
import { TranslateService } from 'ng2-translate';

@Component({
    selector: 'manage-admin',
    template: require('./adminManagement.component.html')
})
export class AdminManagementComponent {

    dialogRef;
    languageId: any;

    constructor(private router: Router, private sessionHandler:SessionHandler, public httpService : HttpService, public dialog: MdDialog,
                private translate: TranslateService) {
        this.languageId = this.sessionHandler.getItem('languageId');
        if(!this.languageId){
            this.languageId = "EN";
        }
        this.translate.use(this.languageId);
    }

    ngOnInit() {}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/adminManagement/adminManagement.component.ts